/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldPlacement } from './FieldPlacement';
import {
    FieldPlacementFromJSON,
    FieldPlacementFromJSONTyped,
    FieldPlacementToJSON,
    FieldPlacementToJSONTyped,
} from './FieldPlacement';

/**
 * 
 * @export
 * @interface FormTemplate
 */
export interface FormTemplate {
    /**
     * Unique identifier for the form template
     * @type {number}
     * @memberof FormTemplate
     */
    id: number;
    /**
     * Company that owns this template
     * @type {number}
     * @memberof FormTemplate
     */
    companyId: number;
    /**
     * Template name
     * @type {string}
     * @memberof FormTemplate
     */
    name: string;
    /**
     * Template description
     * @type {string}
     * @memberof FormTemplate
     */
    description?: string | null;
    /**
     * Template category (e.g., "Onboarding", "Inspection")
     * @type {string}
     * @memberof FormTemplate
     */
    category?: string | null;
    /**
     * URL to fetch the PDF template (e.g., /api/form-templates/:id/pdf)
     * @type {string}
     * @memberof FormTemplate
     */
    pdfTemplateUrl: string;
    /**
     * Field placement definitions for claim data mapping on the PDF
     * @type {Array<FieldPlacement>}
     * @memberof FormTemplate
     */
    fieldPlacements: Array<FieldPlacement>;
    /**
     * Whether the template is active
     * @type {boolean}
     * @memberof FormTemplate
     */
    isActive: boolean;
    /**
     * Display order for sorting templates
     * @type {number}
     * @memberof FormTemplate
     */
    displayOrder: number;
    /**
     * User ID who created the template
     * @type {number}
     * @memberof FormTemplate
     */
    createdBy: number;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof FormTemplate
     */
    createdAt: Date;
    /**
     * Last update timestamp
     * @type {Date}
     * @memberof FormTemplate
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the FormTemplate interface.
 */
export function instanceOfFormTemplate(value: object): value is FormTemplate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('pdfTemplateUrl' in value) || value['pdfTemplateUrl'] === undefined) return false;
    if (!('fieldPlacements' in value) || value['fieldPlacements'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function FormTemplateFromJSON(json: any): FormTemplate {
    return FormTemplateFromJSONTyped(json, false);
}

export function FormTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': json['category'] == null ? undefined : json['category'],
        'pdfTemplateUrl': json['pdfTemplateUrl'],
        'fieldPlacements': ((json['fieldPlacements'] as Array<any>).map(FieldPlacementFromJSON)),
        'isActive': json['isActive'],
        'displayOrder': json['displayOrder'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function FormTemplateToJSON(json: any): FormTemplate {
    return FormTemplateToJSONTyped(json, false);
}

export function FormTemplateToJSONTyped(value?: FormTemplate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'name': value['name'],
        'description': value['description'],
        'category': value['category'],
        'pdfTemplateUrl': value['pdfTemplateUrl'],
        'fieldPlacements': ((value['fieldPlacements'] as Array<any>).map(FieldPlacementToJSON)),
        'isActive': value['isActive'],
        'displayOrder': value['displayOrder'],
        'createdBy': value['createdBy'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

